import SchemePopupLayout from "./SchemePopupLayout";

const MicroFinanceSchemePopup = ({ onClose }) => {
  return (
    <SchemePopupLayout
      title="Micro-Finance Scheme"
      intro="The Micro-Finance Scheme provides small-scale financial assistance to eligible minority beneficiaries, especially through self-help groups and partner agencies, to support livelihood activities and micro-enterprises."
      eligibility={[
        "Applicant must belong to a notified minority community.",
        "Beneficiary should be part of an eligible self-help group or agency-supported activity.",
        "Annual family income should fall within NMDFC income limits.",
        "The proposed activity should support income generation or livelihood development.",
      ]}
      documents={[
        "Aadhaar Card / Identity Proof",
        "Address Proof",
        "Income Certificate",
        "Minority Community Certificate",
        "Self-Help Group Details",
        "Bank Account Details",
        "Project / Activity Details",
        "Passport-size Photograph",
      ]}
      applyLabel="Apply for Micro-Finance Scheme"
      videoUrl="https://www.youtube.com/embed/tzhyZkp3le4"
      onClose={onClose}
    />
  );
};

export default MicroFinanceSchemePopup;
